import React from 'react'
import styled from 'styled-components'
import { getInsightContentTypeDisplayText } from 'components/insightContent/utils/utils'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
// @ts-ignore
import { Dialog, Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import messageUtil from 'utils/messageUtil'
import AccordionSectionType from 'components/insightContent/enum/AccordionSectionType'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { CountTypeStrings } from 'enums/CountType'
import { InsightContentSettingType } from 'components/insightContent/types'
import AccordionGroup from 'components/insightContent/visualization/AccordionGroup'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import GoToAnalysisButton from 'components/insightContent/visualization/GoToAnalysisButton'
import { sendTypedMessage } from 'utils/iframeUtil'
import { toExternal } from 'vo/util'
import { useEmojiNameToDisplayMap } from 'hooks/useEmojiState'
import {
  TopInfoBox,
  TopInfoRight,
  StyledTermContainer,
  StyledTermContent
} from 'components/insightContent/visualization/InfoBox/index.css'
import { InsightViewOptionStrings } from 'enums/InsightViewOption'
import InsightDialog from 'components/insightContent/visualization/InsightDialog'
import { getDisplayText, resolveTooltip } from './utils'

const Name = styled.span`
  font-weight: ${sys.fontWeight.semibold};
`

const DIALOG_CONTENT_HEIGHT = '460px'

interface InsightModalProps {
  open: boolean
  onClose: () => void
  title?: string
  countType?: CountTypeStrings
  selectedInsights?: InsightData[]
  detailSetting?: InsightContentSettingType
  timeUnits?: MetricTimeUnitStrings[]
  forceNotScale?: boolean
  widgetSettingWithSelection?: any
  viewOption?: InsightViewOptionStrings
  widgetId?: number
}

const InsightModal = ({
  open,
  title,
  countType,
  selectedInsights,
  onClose,
  detailSetting,
  timeUnits,
  forceNotScale,
  widgetSettingWithSelection,
  viewOption,
  widgetId
}: InsightModalProps) => {
  const theme = useDisplayTheme() as Theme
  const emojiNameToDisplayMap = useEmojiNameToDisplayMap()

  function goToAnalysis() {
    sendTypedMessage('goToAnalysis', toExternal(widgetSettingWithSelection))
  }

  return (
    <InsightDialog open={open} onClose={onClose}>
      <Dialog.DialogTitle>{title}</Dialog.DialogTitle>
      <TopInfoBox mode={theme}>
        {selectedInsights?.map((item: InsightData) => (
          <StyledTermContainer key={item.name}>
            <Tooltip
              mode={theme}
              enabled
              content={resolveTooltip(item, viewOption!, emojiNameToDisplayMap!)}>
              <StyledTermContent mode={theme}>
                {getDisplayText(item.name!, viewOption!, emojiNameToDisplayMap!)}
              </StyledTermContent>
            </Tooltip>
          </StyledTermContainer>
        ))}

        <TopInfoRight>
          <GoToAnalysisButton onClick={() => goToAnalysis()} />
        </TopInfoRight>
      </TopInfoBox>
      <Dialog.DialogContent height={DIALOG_CONTENT_HEIGHT}>
        <AccordionGroup
          timeUnits={timeUnits}
          forceNotScale={forceNotScale}
          countType={countType}
          insightContentsConfig={[
            {
              accordionTitle: getInsightContentTypeDisplayText(AccordionSectionType.SUMMARY),
              accordionContents: [
                {
                  insightContentType: InsightContentType.TRENDING_TOTAL_MEASURE,
                  detailSetting
                },
                {
                  insightContentType: InsightContentType.TRENDING_SINGLE_MEASURE,
                  detailSetting,
                  widgetId,
                  renderNameMeasureTitleContent: () => (
                    <>
                      <Name>
                        {detailSetting?.selectionName &&
                          getDisplayText(
                            detailSetting.selectionName,
                            viewOption!,
                            emojiNameToDisplayMap
                          )}
                      </Name>
                      &nbsp;
                      {messageUtil.countType(countType!)}
                    </>
                  )
                }
              ]
            },
            {
              accordionTitle: getInsightContentTypeDisplayText(AccordionSectionType.SOUND_BITE),
              accordionContents: [
                {
                  insightContentType: InsightContentType.SOUND_BITE,
                  detailSetting
                }
              ]
            }
          ]}
        />
      </Dialog.DialogContent>
      <Dialog.DialogActions />
    </InsightDialog>
  )
}

export default InsightModal
